<template>    
  <div class="content">
 
    <b-container fluid >
      <div>
        <card class="no-border-card" body-classes=" p-4" footer-classes="pb-2">

          <b-row class="justify-content-md-center" align-v="center" >
            <b-col>
              <h1 class="mb-0">Users</h1>
            </b-col>
            <b-col class="float-right">
              <base-button icon type="success" class="float-right"  @click="show_new_user_modal()" >
                <span class="btn-inner--icon"><span class="material-icons material-icons-outlined md-18">add_circle_outline</span></span>
                <span class="btn-inner--text">Create User</span>
              </base-button>
            </b-col>
          </b-row>
        </card>

        <!-- users table -->
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2" v-if="$parent.users.length > 0">
          <div>
            <b-col class="d-flex justify-content-center justify-content-sm-between flex-wrap float-right mb-4">
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <!--
              <div>
                <base-input v-model="searchQuery"
                            prepend-icon="fas fa-search"
                            placeholder="Search...">
                </base-input>
              </div>
              -->
            </b-col>
          </div>
          <div>
            <!-- TODO change this row-key in the other table vues? -->
            <el-table :data="tableData"
                      row-key="user_uuid"
                      header-row-class-name="thead-light"
                      @sort-change="sortChange"
                      >
                      

          


                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  v-bind="column"
                >
                </el-table-column>

               



                <el-table-column min-width="150px" align="right" label="Users">

                  <div slot-scope="{$index, row}" class="d-flex">
                    <div v-if="row.user_uuid != $parent.active_user.user_uuid" class="table_button_padding">
                      <b-button variant="default" @click="edit_permissions_table($index)">
                        <span style="font-weight:600;font-size:.875rem;">Permissions</span>
                        <div v-if="row && row.permissions && row.permissions.length" class="button_number_fix">
                          <b-badge variant="default" class="badge-circle badge-lg border-white">{{row.permissions.length}}</b-badge>
                        </div>
                        <div v-else  class="button_number_fix">
                          <b-badge variant="default" class="badge-circle badge-lg border-white">0</b-badge>
                        </div>
                      </b-button>
                    </div>
                    <div v-else>
                        <em>You can't edit your own permissions</em>
                    </div>
                  </div>
                
                </el-table-column>



                <el-table-column min-width="80px" align="right" label="Active">
                  <div slot-scope="{$index, row}" class="d-flex" @click="change_this_user_inline($index,row)">
                    <base-switch class="mr-1" v-model="row.is_active" ></base-switch> 
                  </div>
                </el-table-column>

                <el-table-column min-width="80px" align="right" label="Administrator">
                  <div slot-scope="{$index, row}" class="d-flex" @click="change_this_user_inline($index,row)">
                    <base-switch class="mr-1" v-model="row.admin" ></base-switch> 
                  </div>
                </el-table-column>

                <!--
                <el-table-column min-width="100px" align="right" label="Actions">
                  <div slot-scope="{$index, row}" class="d-flex">
                    
                      <i class="text-white ni ni-ruler-pencil"></i>
                    </base-button>
                    <base-button
                      @click.native="handleDelete($index, row)"
                      class="remove btn-link"
                      type="danger"
                      size="md"
                      icon
                    >
                      <i class="text-white ni ni-fat-remove"></i>
                    </base-button>
                  </div>
                </el-table-column>

                -->

             
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{selectedRows.length}} rows selected
                </span>
              </p>

            </div>
            <base-pagination
              class="pagination-no-border"
              :current="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>
        </card>
        <!-- users table -->

      </div>

      <!-- new user modal -->
      <div>
      
        <modal :show.sync="modals.new_user.show_modal" class="modal-xl" body-classes="p-0" id="new_user_modal" ref="new_user_modal" >


          <card 
                header-classes="bg-transparent pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0 mb-0">

              <div class="text-muted text-center mt-2 mb-3">
                <h2>Create New User</h2>
              </div>

              <div v-if="modals.new_user.errors.length > 0">
                <b-alert show variant="danger" v-for="new_user_errors in modals.new_user.errors"
                                :error_text="new_user_errors" >
                  <strong>{{new_user_errors}}</strong>
                </b-alert>
              </div>

              <b-form role="form">
                <base-input alternative
                            v-model="modals.new_user.form_data.first_name"
                            class="mb-3"
                            placeholder="First Name"
                            prepend-icon="badge">
                </base-input>

                <base-input alternative
                            v-model="modals.new_user.form_data.last_name"
                            class="mb-3"
                            placeholder="Last Name"
                            prepend-icon="badge">
                </base-input>

                <base-input alternative
                            v-model="modals.new_user.form_data.email"
                            class="mb-3"
                            placeholder="Email"
                            prepend-icon="email">
                </base-input>

                <base-input alternative
                            v-model="modals.new_user.form_data.cell_phone"
                            type="tel"
                            class="mb-3"
                            placeholder="Cell Phone"
                            prepend-icon="phone_iphone">
                </base-input>

                <b-form-group label="Administrator" style="font-weight: 600;font-size: 0.875rem;" class="mb-2">
                  <base-switch class="mr-1" v-model="modals.new_user.form_data.admin"></base-switch>
                </b-form-group>

                <b-form-group label="Active" style="font-weight: 600;font-size: 0.875rem;" class="mb-2">
                  <base-switch class="mr-1" v-model="modals.new_user.form_data.is_active"></base-switch>
                </b-form-group>

                <b-form-group label="Permissions" style="font-weight: 600;font-size: 0.875rem;" class="mb-2 table_button_padding">
                  <b-button variant="default" @click="launch_new_user_permissions_modal()">
                    <span style="font-weight:600;font-size:.875rem;">Permissions</span>
                    <div v-if="this.modals.new_user.form_data && this.modals.new_user.form_data.permissions && this.modals.new_user.form_data.permissions.length"  class="button_number_fix">
                      <b-badge variant="default" class="badge-circle badge-lg border-white">{{this.modals.new_user.form_data.permissions.length}}</b-badge>
                    </div>
                    <div v-else  class="button_number_fix">
                      <b-badge variant="default" class="badge-circle badge-lg border-white">0</b-badge>
                    </div>
                  </b-button>
                </b-form-group>

              </b-form>

              

          </card>

          
      

         <template slot="footer">
          <base-button type="danger" @click="close_new_user_modal()">Cancel</base-button>
          <base-button type="success" @click="submit_new_user()" :disabled="modals.new_user.is_busy" ref="create_user_button">Create User <span v-if="modals.new_user.is_busy" class="material-icons material-icons-outlined">hourglass_empty</span> </base-button>
          

        </template>
        </modal>


      </div>


      <modal :show.sync="modals.edit_permissions.show_modal">
        <h6 slot="header" class="modal-title">User Permissions:</h6>

        <div>
          <base-input label="Users">
            <el-select v-model="modals.edit_permissions.permissions.users" filterable multiple 
                      placeholder="Permissions"> 
              <el-option v-for="users in $parent.permissions.users"
                        :key="users"
                        :label="users"
                        :value="users">
              </el-option>
            </el-select>
          </base-input>

          <base-input label="Campaigns">
            <el-select v-model="modals.edit_permissions.permissions.campaigns" filterable multiple 
                      placeholder="Permissions"> 
              <el-option v-for="campaigns in $parent.permissions.campaigns"
                        :key="campaigns"
                        :label="campaigns"
                        :value="campaigns">
              </el-option>
            </el-select>
          </base-input>

          <base-input label="Scripts">
            <el-select v-model="modals.edit_permissions.permissions.scripts" filterable multiple 
                      placeholder="Permissions"> 
              <el-option v-for="scripts in $parent.permissions.scripts"
                        :key="scripts"
                        :label="scripts"
                        :value="scripts">
              </el-option>
            </el-select>
          </base-input>

          <base-input label="Lists">
            <el-select v-model="modals.edit_permissions.permissions.lists" filterable multiple 
                      placeholder="Permissions"> 
              <el-option v-for="lists in $parent.permissions.lists"
                        :key="lists"
                        :label="lists"
                        :value="lists">
              </el-option>
            </el-select>
          </base-input>

          <base-input label="Contacts">
            <el-select v-model="modals.edit_permissions.permissions.contacts" filterable multiple 
                      placeholder="Permissions"> 
              <el-option v-for="contacts in $parent.permissions.contacts"
                        :key="contacts"
                        :label="contacts"
                        :value="contacts">
              </el-option>
            </el-select>
          </base-input>

          <base-input label="Messages">
            <el-select v-model="modals.edit_permissions.permissions.messages" filterable multiple 
                      placeholder="Permissions"> 
              <el-option v-for="messages in $parent.permissions.messages"
                        :key="messages"
                        :label="messages"
                        :value="messages">
              </el-option>
            </el-select>
          </base-input>

          <base-input label="Survey Questions">
            <el-select v-model="modals.edit_permissions.permissions.survey_questions" filterable multiple 
                      placeholder="Permissions"> 
              <el-option v-for="survey_questions in $parent.permissions.survey_questions"
                        :key="survey_questions"
                        :label="survey_questions"
                        :value="survey_questions">
              </el-option>
            </el-select>
          </base-input>

          <base-input label="Quick Replies">
            <el-select v-model="modals.edit_permissions.permissions.quick_replies" filterable multiple 
                      placeholder="Permissions"> 
              <el-option v-for="quick_replies in $parent.permissions.quick_replies"
                        :key="quick_replies"
                        :label="quick_replies"
                        :value="quick_replies">
              </el-option>
            </el-select>
          </base-input>


        </div>

        <template slot="footer">
          <base-button type="link" class="ml-auto" @click="modals.edit_permissions.show_modal = false">Close</base-button>
          <base-button type="primary" @click="save_these_permissions_to_row()" :disable="modals.edit_permissions.is_busy">Save</base-button>
          
        </template>

    </modal>


    </b-container>
    </div>






</template>
<script>
import { Table, TableColumn, Select, Option } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { BasePagination } from '@/components';
import clientPaginationMixin from './PaginatedTables/clientPaginationMixin'
import swal from 'sweetalert2';
import { BModal } from 'bootstrap-vue'



export default {
  mixins: [clientPaginationMixin],
  components: {
    BModal,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      is_inside_change_data_callback: false,
      changed_row_index_numbers: [],
      //propsToSearch: ['user_name'],
      tableColumns: [
        /*
        {
          type: 'selection'  //check boxes for bulk edit in the future
        },*/
        {
          prop: 'first_name',
          label: 'First Name',
          sortable: true
        },
        {
          prop: 'last_name',
          label: 'Last Name',
          sortable: true
        },
        {
          prop: 'email',
          label: 'Email',
          sortable: true
        },
        {
          prop: 'cell_phone',
          label: 'Cell Phone',
          sortable: true
        },
        {
          prop: 'date_created',
          label: 'Date',
          minWidth: 100,
          sortable: true,
          formatter: (value, key, item) => {
            return new Date(item).toDateString();

          }
        }
      ],
      tableData: this.$parent.users || [],
      selectedRows: [],
      editing_existing_user_or_new_user: null,
      currently_editing_permissions_for_this_row: null,
      modals: {
        edit_permissions: {
          show_modal:false,
          is_busy:false,
          
          permissions: {
            users: [],
            scripts: [],
            lists:[],
            campaigns:[],
            messages:[],
            contacts:[],
            survey_questions:[],
            quick_replies:[]
          }
        },
        new_user: {
          show_modal: false,
          is_busy: false,
          user_type_options: [{
            value:'SMS',
            label:'SMS'
          }],
          errors: [

          ],
          default_form_data: {
            org_id:this.$parent.active_org.org_id,
            user_uuid:null,
            first_name:null,
            last_name:null,
            email:null,
            fb_uuid:null,
            permissions:[],
            admin:true,
            front_teammember_id:null,
            cell_phone:null,
            is_active:true,
            last_seen:null,
            date_created:this.$parent.current_timestamp(),
            last_modified:this.$parent.current_timestamp(),
            user_uuid_last_modified: this.$parent.active_user.user_uuid
          },
          form_data: {
            org_id:this.$parent.active_org.org_id,
            user_uuid:null,
            first_name:null,
            last_name:null,
            email:null,
            fb_uuid:null,
            permissions:[],
            admin:true,
            front_teammember_id:null,
            cell_phone:null,
            is_active:true,
            last_seen:null,
            date_created:this.$parent.current_timestamp(),
            last_modified:this.$parent.current_timestamp(),
            user_uuid_last_modified: this.$parent.active_user.user_uuid
          }
        }
      }
    };
  },
  methods: {
    show_new_user_modal: function() {
      this.modals.new_user.show_modal = true
      this.editing_existing_user_or_new_user = 'new_user'
    },
    edit_permissions_table: function(index) {
      
      //set a var to track is editing what row
      this.currently_editing_permissions_for_this_row = index

      let return_this_permission_object = {
        users: [],
        scripts: [],
        lists:[],
        campaigns:[],
        messages:[],
        contacts:[],
        survey_questions:[],
        quick_replies:[]
      }


      this.tableData[this.currently_editing_permissions_for_this_row].permissions.forEach(permission_string => {
        if(permission_string !== 'admin') {
          let break_apart_permission = permission_string.split(":")
          if(break_apart_permission[0] && break_apart_permission[1]) {
            return_this_permission_object[break_apart_permission[0]].push(break_apart_permission[1])
          }
        }
      });

      this.modals.edit_permissions.permissions = return_this_permission_object

      //set if this is editing an existing user table row or a new user modal
      this.editing_existing_user_or_new_user = 'existing_user'
    
      //this.modals.edit_permissions.this_row = row
      //create a modeal
      this.modals.edit_permissions.show_modal = true
    },
    launch_new_user_permissions_modal: function() {
      console.log('debug 509 should set existing user or new user inside new user modal??')
      this.editing_existing_user_or_new_user = 'new_user'
      this.modals.edit_permissions.show_modal = true
    },
    exists_array_filled: function(this_array) {
      if(this_array && this_array !== undefined && this_array !== null && Array.isArray(this_array)) {
        if(this_array.length && this_array.length > 0) {
          return true 
        } else {
          return false
        }
      } else {
        return false
      }
    },
    permission_create_contains_read: function(this_array) {
      if(this.exists_array_filled(this_array)) {
        if (this_array.indexOf("create") > -1) {
          if (this_array.indexOf("read") > -1) {} else {
            //does not have read add it
            this_array.push('read')
          }
        }
      }
      return this_array
    },
    transform_permission_objects_into_string_array: function(this_array) {
      let return_this_array_of_permissions_strings = []
      for(let permission_group in this_array){
        this_array[permission_group].forEach(this_permission => {
          return_this_array_of_permissions_strings.push(`${permission_group}:${this_permission}`)
        });
      }

      return return_this_array_of_permissions_strings
    },
    save_these_permissions_to_row: function() {
      //turn the button into loading\
      this.modals.edit_permissions.is_busy = true
      let errors_skip_post = false
      let fire_this_swal_text = ''

      console.log('editing permissions for row index ' + this.currently_editing_permissions_for_this_row)

      //make sure if is create than has read too
      this.modals.edit_permissions.permissions.users = this.permission_create_contains_read(this.modals.edit_permissions.permissions.users)
      this.modals.edit_permissions.permissions.scripts = this.permission_create_contains_read(this.modals.edit_permissions.permissions.scripts)
      this.modals.edit_permissions.permissions.lists = this.permission_create_contains_read(this.modals.edit_permissions.permissions.lists)
      this.modals.edit_permissions.permissions.campaigns = this.permission_create_contains_read(this.modals.edit_permissions.permissions.campaigns)
      this.modals.edit_permissions.permissions.messages = this.permission_create_contains_read(this.modals.edit_permissions.permissions.messages)
      this.modals.edit_permissions.permissions.contacts = this.permission_create_contains_read(this.modals.edit_permissions.permissions.contacts)
      this.modals.edit_permissions.permissions.quick_replies = this.permission_create_contains_read(this.modals.edit_permissions.permissions.quick_replies)
      this.modals.edit_permissions.permissions.survey_questions = this.permission_create_contains_read(this.modals.edit_permissions.permissions.survey_questions)
      
      //if has no permissions set to inactive?
      if(
        this.exists_array_filled(this.modals.edit_permissions.permissions.users) === false &&
        this.exists_array_filled(this.modals.edit_permissions.permissions.scripts) === false &&
        this.exists_array_filled(this.modals.edit_permissions.permissions.lists) === false &&
        this.exists_array_filled(this.modals.edit_permissions.permissions.campaigns) === false &&
        this.exists_array_filled(this.modals.edit_permissions.permissions.messages) === false && 
        this.exists_array_filled(this.modals.edit_permissions.permissions.contacts) === false
      ) {
        errors_skip_post = true
        fire_this_swal_text = 'No permissions were set'
        console.log('debug no permissions were set in this modal')
        if(this.editing_existing_user_or_new_user === 'existing_user') {
          this.tableData[this.currently_editing_permissions_for_this_row].is_active = false
        } else if(this.editing_existing_user_or_new_user === 'new_user') {
          this.modals.new_user.form_data.is_active = false
        } else {
          console.log('error must pass table or new_user into save_these_permissions_to_row functiohn')
        }
      }

      //if there is permissions to send messages endsure that there are minimally read permissions for scripts, campaigns, lists, contacts
      if(this.exists_array_filled(this.modals.edit_permissions.permissions.messages)) {
        console.log('debug 587 has permissions messages')

        if(
          this.modals.edit_permissions.permissions.messages.includes('send') ||
          this.modals.edit_permissions.permissions.messages.includes('send_bulk') ||
          this.modals.edit_permissions.permissions.messages.includes('reply')
        ) {
          console.log('debug has one of three messages')

          //make sure has miinimally read in each
          if(
            !this.exists_array_filled(this.modals.edit_permissions.permissions.campaigns) || 
            !this.modals.edit_permissions.permissions.campaigns.includes('read') ||
            !this.modals.edit_permissions.permissions.contacts.includes('read') ||
            !this.modals.edit_permissions.permissions.lists.includes('read') ||
            !this.modals.edit_permissions.permissions.scripts.includes('read')
          ) {
            console.log('debug does not have read for something')
            console.log(JSON.stringify(this.modals.edit_permissions.permissions))
            errors_skip_post = true
            fire_this_swal_text = 'If giving messages permissions must have at least read permissions for campaigns, contacts, lists, and scripts'
          }

        }
      }
       
      if(errors_skip_post === true) {
          swal.fire({
            title: `Warning`,
            text: fire_this_swal_text || 'Error please contact administrator' ,
            buttonsStyling: false,
            icon: 'warning'
          })
      } else {
        //post this data if it's edit inline existing_user
        let this_array_of_permission_strings = this.transform_permission_objects_into_string_array(this.modals.edit_permissions.permissions)

        if(this.editing_existing_user_or_new_user === 'existing_user') {
          //tableData
          this.tableData[this.currently_editing_permissions_for_this_row].permissions = this_array_of_permission_strings

          this.change_this_user(this.currently_editing_permissions_for_this_row,this.tableData[this.currently_editing_permissions_for_this_row],'existing_user')

        }  else if(this.editing_existing_user_or_new_user === 'new_user'){
          this.modals.new_user.form_data.permissions = this_array_of_permission_strings
        } else {
          console.log('debug shuoldne be here needs existing_user or new_user')
        }
      }     

      //clear the permissions in this_mdal
      this.modals.edit_permissions.permissions =
      {
        users: [],
        scripts: [],
        lists:[],
        contacts: [],
        campaigns:[],
        messages:[],
        quick_replies: [],
        survey_questions: []
      }

      //when finished close
      this.modals.edit_permissions.show_modal = false
    },
    change_this_user_inline: function(index,row) {
      console.log(index)
      this.editing_existing_user_or_new_user = 'existing_user'
      if(!this.changed_row_index_numbers.includes(index)) {
        this.changed_row_index_numbers.push(index)
        this.post_new_row_data(index,row)
      }

    },
    change_this_user: function(index,row,editing_existing_user_or_new_user) {
      console.log('debug 648')
      console.log(index)
      console.log(editing_existing_user_or_new_user)
      console.log(JSON.stringify(row))
      if(this.editing_existing_user_or_new_user === 'existing_user') {
        console.log('debug 669 existing_user shouldnt be here?')
          if(!this.changed_row_index_numbers.includes(index)) {
            //this is to avoid dupes wait until the first loads before firing another
            this.changed_row_index_numbers.push(index)
            this.post_new_row_data(index,row)
          }
        
      } else if(this.editing_existing_user_or_new_user === 'new_user') {
        this.post_new_row_data(null,this.modals.new_user.form_data)
      } else {
        console.log('debug error should be here must hve editing_existing_user_or_new_user')
      }
      
    },
    
    removeItemAll: function(arr, value) {
      var i = 0;
      while (i < arr.length) {
        if (arr[i] === value) {
          arr.splice(i, 1);
        } else {
          ++i;
        }
      }
      return arr;
    },
    post_new_row_data: function(index,update_this_user_data) {
        console.log(index)
       
        console.log('debug existing or new user')
        console.log(this.editing_existing_user_or_new_user)

        update_this_user_data.org_id =  this.modals.new_user.default_form_data.org_id
        update_this_user_data.user_uuid_last_modified = this.$parent.active_user.user_uuid
        update_this_user_data.last_modified = this.$parent.current_timestamp()

       // console.log('update_this_user_data that have been updated:')
        //console.log(JSON.stringify(update_this_user_data))

        axios.post('https://'+this.$parent.use_this_api_domain+'/admin/users', update_this_user_data, {
          headers: {
            'Authorization': 'Bearer ' + this.$parent.active_user_jwt
          }
        })
        .then((results,error) => {

          if(error) {console.log(JSON.stringify(error))}
          if(results) {
            console.log(JSON.stringify(results))
            console.log(this.editing_existing_user_or_new_user)
            //if it's a new user push into the users object OR TODO does it need to go into tableData?
            if(this.editing_existing_user_or_new_user === 'new_user') {
              this.tableData.unshift(results.data)
            }
            
          }

          //is tableData inline edit row
          if(this.editing_existing_user_or_new_user === 'existing_user') {
            this.removeItemAll(this.changed_row_index_numbers,index)
            this.editing_existing_user_or_new_user = null
          } else if(this.editing_existing_user_or_new_user === 'new_user') {
            console.log('debug 727 new_user')
            this.editing_existing_user_or_new_user = null
            
          }

          this.close_new_user_modal()

          
        })
    },
    close_new_user_modal: function() {
      console.log('debug close_new_user_modal')
      //reset the data
      this.modals.new_user.form_data = this.modals.new_user.default_form_data 

      //clear any erors 
      this.modals.new_user.errors = []
      //close
      this.modals.new_user.show_modal = false
      this.modals.new_user.is_busy = false

    },
    submit_new_user: function(this_event) {
      
      console.log('submiting this user: ')
      console.log(this.modals.new_user.form_data)

      this.editing_existing_user_or_new_user = 'new_user'
      

      //make sure has a few details
      /*
      if(!this.modals.new_user.form_data.cell_phone) {
        this.modals.new_user.errors.push("Must provide a cell phone")
      } else {
        this.modals.new_user.errors = this.modals.new_user.errors.filter(e => e !== "Must provide a cell phone")
        //make sure formatted
        this.modals.new_user.form_data.cell_phone = this.modals.new_user.form_data.cell_phone.replace(/\)/g,'').replace(/\(/g,'').replace(/\-/g,'').replace(/\ /g,'').replace(/\+/g,'').replace(/^\++/, '')
        if (this.modals.new_user.form_data.cell_phone.length === 11) {
          if(this.modals.new_user.form_data.cell_phone.startsWith('1')) {
              this.modals.new_user.form_data.cell_phone = "+"+this.modals.new_user.form_data.cell_phone
          } else {
            this.modals.new_user.errors.push("Phone number is not correct. Format like +13032224444")
          }
        } else if (this_the_number_to_verify.length === 10) {
            this.modals.new_user.form_data.cell_phone = "+1" + this.modals.new_user.form_data.cell_phone
        } else if (this_the_number_to_verify.length < 10) {
          this.modals.new_user.errors.push("Must have correct phone number")
        }
      }
      */

      if(this.modals.new_user.form_data.first_name == null || !this.modals.new_user.form_data.first_name) {
        this.modals.new_user.errors.push("Must have a first name")
      } else  {
        //capitalize
        this.modals.new_user.form_data.first_name = helpers.capitalize_first_letter(this.modals.new_user.form_data.first_name)
        this.modals.new_user.errors = this.modals.new_user.errors.filter(e => e !== "Must have a first name")
      }

      if(this.modals.new_user.form_data.last_name == null || !this.modals.new_user.form_data.last_name) {
        this.modals.new_user.errors.push("Must have a last name")
      } else {
        this.modals.new_user.errors = this.modals.new_user.errors.filter(e => e !== "Must have a last name")
        this.modals.new_user.form_data.last_name = helpers.capitalize_first_letter(this.modals.new_user.form_data.last_name)
      }

      if(this.modals.new_user.form_data.is_active === null) {
        this.modals.new_user.errors.push("Must select active status")
      } else {
        this.modals.new_user.errors = this.modals.new_user.errors.filter(e => e !== "Must select active status")
      }

      if(this.modals.new_user.form_data.admin === null) {
        this.modals.new_user.errors.push("Must select admin status")
      } else {
        this.modals.new_user.errors = this.modals.new_user.errors.filter(e => e !== "Must select admin status")
      }

      if(!this.modals.new_user.form_data.permissions || !Array.isArray(this.modals.new_user.form_data.permissions) || this.modals.new_user.form_data.permissions.length <1) {
        this.modals.new_user.errors.push("Must have at least one permission")
      } else {
        this.modals.new_user.errors = this.modals.new_user.errors.filter(e => e !== "Must have at least one permission")
      }

      if(this.modals.new_user.errors.length > 0) {
        //do nothing
        this.modals.new_user.is_busy = false
        this.editing_existing_user_or_new_user = null
      } else {
        
        //show modal as loading
        this.modals.new_user.is_busy = true

        //post the data
        this.post_new_row_data(null,this.modals.new_user.form_data)
      }

    },

    paginationChanged: function(page) {
      this.pagination.currentPage = page
    },
    handleLike: function(index, row) {
      swal.fire({
        title: `You liked ${row.name}`,
        buttonsStyling: false,
        type: 'success',
        confirmButtonClass: 'btn btn-success btn-fill'
      });
    },
    handleEdit: function(index, row) {
      swal.fire({
        title: `You want to edit ${row.name}`,
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-info btn-fill'
      });
    },
    handleDelete: function(index, row) {
      console.log(row);
      swal.fire({
        title: `Are you sure you want to delete ${row.user_name}?`,
        text: `You won't be able to revert this!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
          swal.fire({
            title: 'Deleted!',
            text: `You deleted ${row.user_name}`,
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          });
        }
      });
    },
    deleteRow: function(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange: function(selectedRows) {
      this.selectedRows = selectedRows
    },
    handleMouseLeave() {
      this.store.commit('setHoverRow', null);
      if (this.hoverState) this.hoverState = null;
    },
    sortChange() {
      console.log('sortChange')
    }
  }
};


</script>
<style>
  .no-border-card .card-footer{
    border-top: 0;
  }
  .table_row_loading {
    opacity: .5;

  }
  div.el-table  .table_row_loading {
    background-color: var(--gray) !important;
  }
  .button_number_fix {
    display:inline;
    padding-left:10px;
  }
  .table_button_padding .btn {
    padding-right: 10px;
  }
</style>
